export default __webpack_public_path__ + "static/media/26.08d48a4b.jpg";